// extracted by mini-css-extract-plugin
export var bounce = "_p0-1";
export var generatingText = "_p0-6";
export var lightning = "_p0-4";
export var popup = "_p0-5";
export var progressBar = "_p0-7";
export var progressFill = "_p0-8";
export var progressShimmer = "_p0-9";
export var progressText = "_p0-a";
export var shimmer = "_p0-3";
export var uploadIcon = "_p0-0";
export var uploadingText = "_p0-2";